"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vp_footer_1 = require("@components/vp-footer");
var config = {
    columns: [
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.ch/de/wer-sind-wir'
                    },
                    text: 'Wer sind wir?',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/de/marken'
                    },
                    text: 'Unsere Marken',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/de/agb'
                    },
                    text: 'AGB',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/de/jobs'
                    },
                    text: 'Jobs',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/de/impressum'
                    },
                    text: 'Impressum',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/de/agb#2'
                    },
                    text: 'Datenschutzerklärung',
                    type: 'link'
                }
            ],
            title: 'Über uns'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.ch/de/faq'
                    },
                    text: 'FAQ',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/de/kontakt'
                    },
                    text: 'Kontaktieren Sie uns',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/de/faq#gutscheine_geschenkkarten-4'
                    },
                    text: 'Bedingungen Promo-Codes',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/de/kontakt-partner'
                    },
                    text: 'Partner werden',
                    type: 'link'
                }
            ],
            title: 'Hilfe & Kontakt'
        },
        {
            items: [
                {
                    icon: vp_footer_1.Icons.Facebook,
                    linkProps: {
                        href: '//www.facebook.com/Veepee.Ch.DE/',
                        target: '_blank'
                    },
                    text: 'Facebook',
                    type: 'link'
                },
                {
                    icon: vp_footer_1.Icons.Instagram,
                    linkProps: {
                        href: '//www.instagram.com/veepee_ch/',
                        target: '_blank'
                    },
                    text: 'Instagram',
                    type: 'link'
                }
            ],
            mobile: { hideTitle: true },
            title: 'Folgen Sie Uns'
        },
        {
            items: [{
                    text: '',
                    type: 'countryDropdown'
                }],
            title: 'VP, Aus Liebe zu Marken'
        }
    ],
    country: 'CH',
    flag: 'CH-DE',
    lang: 'de',
    logoSubtitle: ''
};
exports.default = config;
